
import React from 'react';
import { Button } from "@/components/ui/button";
import { Trash2 } from "lucide-react";
import { SavedState } from '@/components/team-details/types/selector-types';

interface StatesListProps {
  states: SavedState[];
  onLoadState: (state: SavedState) => void;
  onLoadLeagueTable: (state: SavedState) => void;
  onDeleteState: (id: number) => void;
}

const StatesList: React.FC<StatesListProps> = ({
  states,
  onLoadState,
  onLoadLeagueTable,
  onDeleteState,
}) => {
  const handleDelete = async (id: number, e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    await onDeleteState(id);
  };

  return (
    <div className="grid gap-4">
      {states.map((state) => (
        <div key={state.id} className="flex gap-4 items-center p-4 border rounded-lg">
          <div className="flex flex-col">
            <span className="font-medium">{state.name}</span>
            {state.country && (
              <span className="text-sm text-gray-500">
                {state.country} - {state.league} ({state.year})
              </span>
            )}
          </div>
          <div className="flex gap-2 ml-auto items-center">
            <Button onClick={() => onLoadState(state)}>
              Load Data Table
            </Button>
            <Button onClick={() => onLoadLeagueTable(state)}>
              Load League Table
            </Button>
            <Button 
              variant="destructive" 
              onClick={(e) => handleDelete(state.id, e)}
              className="flex items-center gap-2"
            >
              <Trash2 className="h-4 w-4" />
              Delete
            </Button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default StatesList;
